export default __webpack_public_path__ + "static/media/down-arrow.3e652fe3.svg";